import { defineMessages } from 'react-intl';

export const productGroupsPageMessages = defineMessages({
  title: {
    id: 'productGroups.title',
    defaultMessage: 'Product Groups',
    description: 'Products page headline',
  },
  templates: {
    id: 'productGroups.templates',
    defaultMessage: 'Tailoring Proposals',
    description: 'Templates page headline',
  },
  addProduct: {
    id: 'productGroups.addProduct',
    defaultMessage: 'Add Product Group',
    description: 'Products page add product button',
  },
  noProductsFound: {
    id: 'productGroups.noProductsFound',
    defaultMessage: 'No Product Groups found for the current search query.',
    description: 'Products page no products found message',
  },
  noResults: {
    id: 'productGroups.noResults',
    defaultMessage: 'No Product Groups have been created yet.',
    description: 'Products page no results message',
  },
  noResultsButton: {
    id: 'productGroups.noResultsButton',
    defaultMessage: 'Create new Product Group',
    description: 'Products page no results button',
  },
  gridViewButton: {
    id: 'productGroups.gridViewButton',
    defaultMessage: 'Grid view',
    description: 'Products page grid view button',
  },
  tableViewButton: {
    id: 'productGroups.tableViewButton',
    defaultMessage: 'Table view',
    description: 'Products page table view button',
  },
  searchBarPlaceholder: {
    id: 'productGroups.searchBarPlaceholder',
    defaultMessage: 'Search Product Groups',
    description: 'Products page search bar placeholder',
  },
  filterBarPlaceholder: {
    id: 'productGroups.filterBarPlaceholder',
    defaultMessage: 'Filter Product Groups',
    description: 'Products page filter bar placeholder',
  },
  filterBarText: {
    id: 'productGroups.filterBarText',
    defaultMessage: 'Show:',
    description: 'Products page filter bar text',
  },
  filterBarOptionAllProducts: {
    id: 'productGroups.filterBarOptionAllProducts',
    defaultMessage: 'All Product Groups',
    description: 'Products page filter bar option all products',
  },
  filterBarOptionMyProducts: {
    id: 'productGroups.filterBarOptionMyProducts',
    defaultMessage: 'My Product Groups',
    description: 'Products page filter bar option my products',
  },
});

export const formValidationMessages = defineMessages({
  required: {
    id: 'form.validation.required',
    defaultMessage: '{fieldName} is required.',
    description: 'Form validation required message',
  },
  minimumLength: {
    id: 'form.validation.minimumLength',
    defaultMessage: 'Minimum of {minLength} characters long.',
    description: 'Form validation minimum length message',
  },
  maximumLength: {
    id: 'form.validation.maximumLength',
    defaultMessage: 'Maximum of {maxLength} characters long.',
    description: 'Form validation minimum length message',
  },
  invalidCharacters: {
    id: 'form.validation.invalidCharacters',
    defaultMessage: 'Entered characters are not allowed.',
    description: 'Form validation invalid characters message',
  },
});

export const productGroupFormTranslations = defineMessages({
  nameInputLabel: {
    id: 'productGroups.productGroupForm.nameInputLabel',
    defaultMessage: 'Product Group name',
    description: 'Product form name input label',
  },
  nameInputPlaceholder: {
    id: 'productGroups.productGroupForm.nameInputPlaceholder',
    defaultMessage: 'Enter Product Group name',
    description: 'Product form name input placeholder',
  },
  descriptionInputLabel: {
    id: 'productGroups.productGroupForm.descriptionInputLabel',
    defaultMessage: 'Product Group description',
    description: 'Product form description input label',
  },
  descriptionInputPlaceholder: {
    id: 'productGroups.productGroupForm.descriptionInputPlaceholder',
    defaultMessage: 'Enter Product Group description',
    description: 'Product form description input placeholder',
  },
  sumbitButton: {
    id: 'productGroups.productGroupForm.sumbitButton',
    defaultMessage: 'Submit',
    description: 'Product form submit button',
  },
  backButton: {
    id: 'productGroups.productGroupForm.backButton',
    defaultMessage: 'Cancel',
    description: 'Product form back button',
  },
});

export const productGroupDialogTranslations = defineMessages({
  addProductTitle: {
    id: 'productGroups.dialog.addProductTitle',
    defaultMessage: 'New Product Group',
    description: 'Add product dialog title',
  },
  editProductTitle: {
    id: 'productGroups.dialog.editProductTitle',
    defaultMessage: 'Edit Product Group',
    description: 'Edit product dialog title',
  },
});

export const productGroupsToastTranslations = defineMessages({
  addProductToast: {
    id: 'productGroups.toast.add',
    defaultMessage: 'Product Group successfully added.',
    description: 'Add product toast message',
  },
  editProductToast: {
    id: 'productGroups.toast.edit',
    defaultMessage: 'Product Group successfully edited.',
    description: 'Edit product toast message',
  },
  deleteProductToast: {
    id: 'productGroups.toast.delete',
    defaultMessage: 'Product Group successfully deleted.',
    description: 'Delete product toast message',
  },
});
